import { createApp } from 'vue'

import Vue3Toastify from 'vue3-toastify'
import App from '@/App.vue'
import { registerPlugins } from '@core/utils/plugins'
import { useAuthStore } from '@/store/auth'

// Styles
import '@core/scss/template/index.scss'
import '@layouts/styles/index.scss'
import 'vue3-toastify/dist/index.css'

// Create vue app
const pinia = createPinia()
const app = createApp(App)

// Register plugins
registerPlugins(app)

// app.use(pinia)

const authStore = useAuthStore()

authStore.initializeFromLocalStorage()

app.use(Vue3Toastify)

// Mount vue app
app.mount('#app')
